import React from "react";
import Layout from "../component/Layout";
import BreadCrumbTerms from "../component/breadcrumb/BreadcrumbTerms";

const ToC = () => {
  return (
    <Layout>
      <div className="privacy-policy-area privacy-policy section-gap ">
        <div className="container">
          <div className="row g-5">
            <div className="content">
              <h4 className="title text-center">Acceptance of Terms</h4>
              <p>
                <p>
                  Welcome to{" "}
                  <strong>MegaGen America’s Marketing Material Platform</strong>{" "}
                  (“we,” “our,” “us”). MegaGen America provides this Platform to
                  support internal sales and marketing activities and to ensure
                  consistent, approved use of MegaGen America branding and
                  materials.
                </p>

                <p>
                  The Marketing Material Platform allows authorized MegaGen
                  America employees and sales representatives to access,
                  download, and use approved marketing assets, including flyers,
                  brochures, product information, and other promotional
                  materials (“Content”) for business purposes only.
                </p>

                <p>
                  These Terms and Conditions (“Terms”) govern your access to and
                  use of the Marketing Material Platform (“Platform”).{" "}
                  <strong>
                    By accessing or using the Platform, you acknowledge that you
                    have read, understood, and agree to comply with and be bound
                    by these Terms.
                  </strong>{" "}
                  If you do not agree to these Terms, you must not access or use
                  the Platform.
                </p>

                <p>
                  Access to the Platform is provided on an individual account
                  basis. Account sharing is strictly prohibited, and all use of
                  the Platform is subject to MegaGen America’s internal policies
                  and approval guidelines.
                </p>

                <p>
                  <strong>Optional Acceptance Line:</strong> By accessing or
                  using the MegaGen America Marketing Material Platform, you
                  agree to be bound by these Terms and Conditions.
                </p>
              </p>
              <h5 className="title">1. Purpose of the Platform</h5>
              <p>
                The MegaGen America Marketing Material Platform is an internal
                resource provided by <strong>MegaGen America</strong> for
                authorized employees and sales representatives. The Platform is
                intended solely for accessing approved marketing and sales
                materials, including but not limited to flyers, brochures,
                product information, and promotional assets.
              </p>
              <h5 className="title">2. Authorized Use</h5>
              <p>
                Access to the Platform is restricted to active, authorized users
                who have been issued individual login credentials by MegaGen
                America.
              </p>
              <p>
                • Each user is provided with a{" "}
                <strong>single, unique account. </strong>
              </p>
              <p>
                • Accounts are for <strong>internal business use only.</strong>{" "}
              </p>
              <p>
                • Users may only access, download, and use materials in
                connection with their official role at MegaGen America.
              </p>
              <h5 className="title">3. Account Responsibility & Security </h5>
              <p>
                Users are responsible for maintaining the confidentiality of
                their login credentials.
              </p>{" "}
              <p>
                • <strong>Account sharing is strictly prohibited.</strong>
              </p>{" "}
              <p>
                • Users may not allow any third party, including other
                employees, contractors, or external partners, to access the
                Platform using their credentials.
              </p>{" "}
              <p>
                • All activity conducted under a user’s account is the
                responsibility of that user.
              </p>
              <h5 className="title">
                4. Marketing Materials & Content Management
              </h5>
              <p>
                All materials available on the Platform are managed by
                designated MegaGen America administrators.
              </p>{" "}
              <p>
                • Administrators may add, update, replace, or remove materials
                at any time.
              </p>{" "}
              <p>
                • Materials may be removed if they are outdated, expired, or no
                longer approved for use.
              </p>{" "}
              <p>
                • Users are responsible for ensuring they are using the most
                current and approved versions of all materials.
              </p>
              <h5 className="title">
                5. Intellectual Property & Usage Restrictions
              </h5>
              <p>
                All content on the Platform is the property of MegaGen America
                or its licensors and is protected by applicable intellectual
                property laws.
              </p>{" "}
              <p>
                • Materials may not be modified, reproduced, distributed, or
                shared externally without prior written authorization from
                MegaGen America.
              </p>{" "}
              <p>
                • Use of materials outside approved business purposes, including
                personal or third-party use, is prohibited.
              </p>
              <h5 className="title">
                6. Employment Status & Account Termination
              </h5>
              <p>
                Access to the Platform is contingent upon active employment or
                authorized representation with MegaGen America.
              </p>
              <p>
                • If a user’s employment or role ends, their account will be
                deactivated or deleted by an administrator.
              </p>{" "}
              <p>• Access will be revoked immediately upon termination.</p>{" "}
              <p>
                • New accounts will be issued to newly onboarded sales
                representatives as needed.
              </p>
              <h5 className="title">
                {" "}
                7. Monitoring, Compliance & Enforcement
              </h5>
              <p>
                MegaGen America reserves the right to monitor Platform usage to
                ensure compliance with these Terms & Conditions.
              </p>{" "}
              <p>
                • Violations may result in temporary suspension or permanent
                termination of access.
              </p>{" "}
              <p>
                • Serious or repeated violations may lead to disciplinary action
                in accordance with MegaGen America policies.
              </p>
              <h5 className="title"> 8. Modifications to Terms</h5>
              <p>
                MegaGen America may update these Terms & Conditions at any time.
              </p>{" "}
              <p>
                • Continued use of the Platform following updates constitutes
                acceptance of the revised terms.
              </p>{" "}
              <h5 className="title"> 9. Acceptance of Terms</h5>
              <p>
                By accessing or using the MegaGen America Marketing Material
                Platform, users acknowledge that they have read, understood, and
                agreed to comply with these Terms & Conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ToC;
